<template>
  <tr :class="rowClasses(row._index)" :draggable="draggable" @dragstart="onDrag($event,row._index)"
      @drop="onDrop($event,row._index)" @dragover="allowDrop($event)" v-if="draggable">
    <slot></slot>
  </tr>
  <tr :class="rowClasses(row._index)" v-else>
    <slot></slot>
  </tr>
</template>
<script>
  export default {
    props: {
      row: Object,
      showTitle: Boolean,
      prefixCls: String,
      draggable: Boolean
    },
    data() {
      return {};
    },
    computed: {
      objData() {
        return this.$parent.objData;
      },
      parent() {
        return this.$parent.$parent.$parent.$parent.$parent;
      }
    },
    methods: {
      onDrag(e, index) {
        e.dataTransfer.setData('index', index);
      },
      onDrop(e, index) {
        const dragIndex = e.dataTransfer.getData('index');
        this.parent.dragAndDrop(dragIndex, index);
        e.preventDefault();
      },
      allowDrop(e) {
        e.preventDefault();
      },
      rowClasses(_index) {
        return [
          `${this.prefixCls}-row`,
          this.rowClsName(_index),
          {
            [`${this.prefixCls}-row-highlight`]: this.objData[_index] && this.objData[_index]._isHighlight,
            [`${this.prefixCls}-row-hover`]: this.objData[_index] && this.objData[_index]._isHover
          }
        ];
      },
      rowClsName(_index) {
        return this.parent.rowClassName(this.objData[_index], _index);
      },
    },
  };
</script>
